import { userRole } from "../constants/appConst";


export const getFolderRole = (user, folderId, idPath) => {
    if (user?.isGlobalAdmin) return userRole.GlobalAdmin;
    if (!user?.folders || !folderId) return 0;

    const normalize = (val) => (val ? String(val).toLowerCase().trim() : "");
    const targetId = normalize(folderId);

    let idsToCheck = [targetId];

    // Inherit permissions from parents found in idPath
    if (typeof idPath === "string" && idPath.trim()) {
        const pathParts = idPath.split("\\").map(normalize);
        idsToCheck = [...new Set([...idsToCheck, ...pathParts])];
    }

    const authorizedFolder = user.folders.find(f =>
        idsToCheck.includes(normalize(f.folderIdentifier))
    );

    return authorizedFolder ? authorizedFolder.role : 0;
};

export const hasFolderRole = (user, folderId, idPath, ...roles) => {
    if (user?.isGlobalAdmin) return true;
    const role = getFolderRole(user, folderId, idPath);
    return roles.includes(role);
};


export const isGlobalAdmin = (user) =>
    user?.isGlobalAdmin === true;

export const canManageUsers = (user) => {
    if (user?.isGlobalAdmin)
        return true;

    return user?.folders?.some(f =>
        f.role === userRole.BusinessUnitAdmin ||
        f.role === userRole.BusinessUnitUserAdministrator
    );
};
export const canCreateRole = (currentUser, targetRole) => {
    if (currentUser?.isGlobalAdmin)
        return true;

    const highestRole = Math.min(
        ...currentUser.folders.map(f => f.role)
    );

    switch (highestRole) {
        case userRole.BusinessUnitAdmin:
            return [
                userRole.BusinessUnitAdmin,
                userRole.BusinessUnitUserAdministrator,
                userRole.BusinessUnitUser
            ].includes(targetRole);

        case userRole.BusinessUnitUserAdministrator:
            return [
                userRole.BusinessUnitUserAdministrator,
                userRole.BusinessUnitUser
            ].includes(targetRole);

        default:
            return false;
    }
};